import "core-js/modules/es6.string.bold.js";
import React from 'react';
import { Button, Box, Text } from '@nerdwallet/currency';
import analytics from '@nerdwallet/analytics';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import classNames from 'classnames';
import styles from '../comparison-grid.module.less';
import { EVENT_TYPES, ENTITY_NAME, ACTION, INTERACTION_TYPE, SECTION_NAME } from '../../lib/analytics-constants';

var StickyBanner = function StickyBanner(_ref) {
  var numEntitiesToCompare = _ref.numEntitiesToCompare,
      entitiesToCompare = _ref.entitiesToCompare,
      onCompareButtonClick = _ref.onCompareButtonClick,
      removeEntityClickHandler = _ref.removeEntityClickHandler;

  var onResetButtonClick = function onResetButtonClick(impressionId) {
    entitiesToCompare.forEach(function (entity) {
      removeEntityClickHandler(entity.marketplaceEntity.uniqueId);
    });
    analytics.track(EVENT_TYPES.ELEMENT_INTERACTED, {
      action: ACTION.CANCEL,
      entity_name: ENTITY_NAME.STICKY_BANNER_RESET_BUTTON,
      element_name: ENTITY_NAME.STICKY_BANNER_RESET_BUTTON,
      interaction_type: INTERACTION_TYPE.PRESS,
      impression_id: impressionId
    });
  };

  var onCompareButtonClickWrapper = function onCompareButtonClickWrapper(impressionId) {
    onCompareButtonClick();
    analytics.track(EVENT_TYPES.ELEMENT_INTERACTED, {
      action: ACTION.CONFIRM,
      entity_name: ENTITY_NAME.STICKY_BANNER_COMPARE_BUTTON,
      element_name: ENTITY_NAME.STICKY_BANNER_COMPARE_BUTTON,
      interaction_type: INTERACTION_TYPE.PRESS,
      impression_id: impressionId
    });
  };

  return /*#__PURE__*/React.createElement(Impression, {
    entityName: ENTITY_NAME.STICKY_BANNER,
    eventType: EVENT_TYPES.ELEMENT_IMPRESSION,
    className: classNames([styles.stickyBanner, styles.showStickyBanner]),
    payload: {
      element_name: ENTITY_NAME.STICKY_BANNER,
      section_name: SECTION_NAME.PREQUAL_RESULTS,
      element_position: null,
      section_position: null
    }
  }, /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (_ref2) {
    var impressionId = _ref2.impressionId;
    return /*#__PURE__*/React.createElement("div", {
      className: numEntitiesToCompare > 0 ? classNames([styles.stickyBanner, styles.showStickyBanner]) : classNames([styles.stickyBanner, styles.hideStickyBanner])
    }, /*#__PURE__*/React.createElement(Box, {
      width: "100",
      display: "flex",
      flexDirection: "row",
      justifyContent: {
        mobile: 'center',
        desktop: 'space-between'
      },
      alignItems: "center",
      margin: "3"
    }, /*#__PURE__*/React.createElement(Box, {
      display: {
        mobile: 'none',
        desktop: 'inline-flex'
      }
    }, /*#__PURE__*/React.createElement(Text, {
      className: classNames([styles.bold])
    }, "".concat(numEntitiesToCompare, " ").concat(numEntitiesToCompare === 1 ? 'offer' : 'offers', " selected"))), /*#__PURE__*/React.createElement(Box, {
      display: "inline-flex",
      width: {
        mobile: '100',
        desktop: 'auto'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      className: classNames([styles.stickyBannerButton, styles.stickyBannerResetButton]),
      onClick: function onClick() {
        return onResetButtonClick(impressionId);
      }
    }, "Reset"), /*#__PURE__*/React.createElement(Button, {
      primary: true,
      onClick: function onClick() {
        return onCompareButtonClickWrapper(impressionId);
      },
      className: classNames([styles.stickyBannerButton, styles.stickyBannerCompareButton])
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames([styles.stickyBannerCompareButtonChildContainer])
    }, /*#__PURE__*/React.createElement(Text, null, "Compare"), /*#__PURE__*/React.createElement("div", {
      className: classNames([styles.stickyBannerCompareButtonBadge])
    }, /*#__PURE__*/React.createElement(Text, null, numEntitiesToCompare)))))));
  }));
};

export default StickyBanner;